import React from 'react';

import { VisuallyHidden } from '@zillow/constellation';
import { Paragraph } from '@zillow/constellation-10';

type Props = {
  errorMessage?: string;
  successMessage?: string;
};

const VisuallyHiddenScreenReader = ({ errorMessage = '', successMessage = '' }: Props): JSX.Element => {
  return (
    <VisuallyHidden>
      <div aria-live="polite">
        {successMessage && <Paragraph>{successMessage}</Paragraph>}
        {errorMessage && <Paragraph>{errorMessage}</Paragraph>}
      </div>
    </VisuallyHidden>
  );
};

export default VisuallyHiddenScreenReader;
